import { Box } from '@mui/material';
import { useState } from 'react';
import global_constant from '../../../assets/json/global_constant.json';
import MultimediaTabContainor from './MultimediaTabContainor';
import MultimediaTabs from './MultimediaTabs';
import MultimediaCTAButtons from './MultimediaCTAButtons';

const MultimediaContainer = ({ editableMultimediaData, setEditableMultimediaData, multimediaData, setMultimediaData, artists, showLoader, entertainment_entity_filter, handleMultimediaCTAButtonsClick }) => {

    const [tabIndex, setTabIndex] = useState(0);
    const {
        language,
        industry,
        country,
        geners_type,
        song_genres,
        movie_genres,
        multimedia_types,
        multimedia_ratio,
        artist_types,
        entertainment_entity_types,
    } = global_constant;

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    return (
        <Box sx={{
            flex: 1,
            height: '100%',
            display: "flex",
            padding: 0,
            flexDirection: "column",
            gap: 0,
        }}>

            <MultimediaTabs tabIndex={tabIndex} handleTabChange={handleTabChange} />

            <MultimediaTabContainor
                tabIndex={tabIndex}
                editableMultimediaData={editableMultimediaData}
                setEditableMultimediaData={setEditableMultimediaData}
                multimediaData={multimediaData}
                setMultimediaData={setMultimediaData}
                showLoader={showLoader}
                global_constant={entertainment_entity_filter}
                artists={artists}
            />

            {/* <MultimediaCTAButtons editableMultimediaData={editableMultimediaData} multimediaData={multimediaData} handleMultimediaCTAButtonsClick={handleMultimediaCTAButtonsClick} /> */}

        </Box>
    )
}

const styles = {

};

export default MultimediaContainer
